import { Tag } from '@omnipresentgroup/design-system';
import { type Employment, EmploymentStatusMap } from '@omnipresentgroup/types';

import { EmploymentStatusIntentMap } from './types';

type Props = {
  employment: Employment;
};

export const EmploymentStatusTag = ({ employment }: Props) => {
  const EmploymentIntent = employment.status
    ? EmploymentStatusIntentMap[employment.status]
    : 'default';

  return (
    <Tag
      id={`employment-status-tag-${employment.id}`}
      intent={EmploymentIntent}
    >
      {EmploymentStatusMap[employment.status]}
    </Tag>
  );
};
